import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'Context/QueryClientContext';
import ObrasApi from 'Data/Obras.api';
import { IObraResponse } from 'Data/interfaces/Obra/IObraListResponse';
import toastHandler from 'Utils/toastHandler';
import { OBRA_QUERY_KEY } from 'Data/keys/QueryKeys';
import { IDeleteSADisciplineRequest } from 'Data/interfaces/Obra/ISolutionSADisciplineRequest';

export const useQueryDeleteDisciplineSA = () => {
  const { mutate, isPending } = useMutation({
    mutationFn: (variables: IDeleteSADisciplineRequest) => {
      return ObrasApi.deleteSADiscipline(variables);
    },
    onMutate: async (variables) => {
      const previousObras = queryClient.getQueryData<IObraResponse[]>(
        [OBRA_QUERY_KEY],
      );
      const previousUniqueObra = queryClient.getQueryData<IObraResponse>(
        [OBRA_QUERY_KEY, Number(variables.ConstructionSiteId)],
      );

      queryClient.setQueryData<IObraResponse[]>([OBRA_QUERY_KEY],
        (old) => {
          return old?.map((obra) => {
            if (
              obra.ConstructionSiteId === variables.ConstructionSiteId &&
              obra.Disciplines && obra.Disciplines.length > 0 &&
              obra.Disciplines.some((discipline: any) => {
                return discipline.ConstructionSiteDisciplinesId === variables.ConstructionSiteDisciplinesId;
              })
            ) {
              obra.Disciplines = obra.Disciplines.filter((discipline: any) => {
                return discipline.ConstructionSiteDisciplinesId !== variables.ConstructionSiteDisciplinesId;
              });
            }
            return obra;
          });
        },
      );
      queryClient.setQueryData<IObraResponse>(
        [OBRA_QUERY_KEY, Number(variables.ConstructionSiteId)],
        (old) => {
          if (old && old.Disciplines && old.Disciplines.length > 0) {
            old.Disciplines = old.Disciplines.filter((discipline: any) => {
              return discipline.ConstructionSiteDisciplinesId !== variables.ConstructionSiteDisciplinesId;
            });
          }
          return old;
        },
      );

      return { previousObras, previousUniqueObra };
    },
    onError: async (error: any, variables, context) => {
      await Promise.all([
        queryClient.cancelQueries({ queryKey: [OBRA_QUERY_KEY] }),
        queryClient.cancelQueries({
          queryKey: [OBRA_QUERY_KEY, Number(variables.ConstructionSiteId)],
        }),
      ]);

      queryClient.setQueryData<IObraResponse[]>(
        [OBRA_QUERY_KEY],
        context?.previousObras,
      );
      queryClient.setQueryData<IObraResponse>(
        [OBRA_QUERY_KEY, Number(variables.ConstructionSiteId)],
        context?.previousUniqueObra,
      );

      const errorMsg = error.errors
        ? error.errors[0].Message
        : 'Erro ao excluir disciplina';
      toastHandler.showError(errorMsg);
    },
  });

  return {
    deleteDisciplineSA: mutate,
    isLoading: isPending,
  };
};
